import * as React from "react";
import {ContactRole, OperationContactRec} from "./OperationContactApi.ts";
import Box from "@mui/material/Box";
import clsx from "clsx";
import css from "./OperationalContactView.module.css";
import Divider from "@mui/material/Divider";


const itemValue = (label: string, value: string) => {
    return (
        <Box className={clsx(css.record)}>
            <Box className={clsx(css.item)}>
                <Box>
                    <Box className={clsx(css.label)}>
                        {label}
                    </Box>
                </Box>
                <Divider className={clsx(css.divider)} flexItem={true}></Divider>
                <Box className={clsx(css.value)}>{value}</Box>
            </Box>
        </Box>
    )
}

const itemRole = (role: string[], roleDef: ContactRole) => {
    return (
        <Box className={clsx(css.record)}>
            {Object.entries(role).map(([_, val], index) => (
                <Box className={clsx(css.item)}>
                    <Box>
                        <Box className={clsx(css.label)}>
                        </Box>
                    </Box>
                    <Divider className={clsx(css.divider)} flexItem={true}></Divider>
                    <Box className={clsx(css.value)}>
                            <Box key={index}>
                                {roleDef[val]}
                            </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    )
}

interface OperationalContactViewProps {
    contacts: OperationContactRec[];
    roleDef: ContactRole;
}

export const OperationalContactView: React.FC<OperationalContactViewProps> = (
    {
        contacts,
        roleDef
    }
) => {
    console.log(contacts);
    return (
        <Box className={clsx(css.operationContactView)}>
            {(contacts ?? []).map((item, index) => (
            <Box key={index} className={clsx(css.contact)}>
                {itemValue('Nazwa:', item.name)}
                {itemValue('Telefon:', item.phone)}
                {itemValue('Mail:', item.email)}
                {itemValue('Opis:', item.description)}

                <Box className={clsx(css.separator)}>
                    Rola w przedsiębiorstwie
                </Box>

                {item.role && Object.keys(item.role).length > 0 &&
                    itemRole(item.role, roleDef)}
            </Box>
        ))}
        </Box>
    );
}
